$ = require('jquery')

GroupMembersDetailCtrl = ($scope ,$filter ,$location ,$routeParams ,groupInfo ,userInfo ,groupStatus , GroupMemberService ,groupDataService ) ->
  angular.element(document.body).css 'min-width', 0

  $(document).ready( ->
    $.fn.isInViewport = () ->
      elementTop = $(this).offset().top
      elementBottom = elementTop + $(this).outerHeight()
      viewportTop = $(window).scrollTop()
      viewportBottom = viewportTop + $(window).height()
      return elementBottom  > viewportTop && elementTop < viewportBottom

    document.body.scrollTop = document.documentElement.scrollTop = 0
    curOffMemTool = $('#member-toolbar')[0].offsetTop
    _originalSize = $(window).width() + $(window).height()

    window.onscroll = ->
      # mem toolbar
      showKeyboard =  $("input").is(":focus")
      y = $(this).scrollTop()
      if y >= curOffMemTool && !showKeyboard
        $('.member-toolbar-wrap-content').css("min-height", $('#member-toolbar').outerHeight())
        $('#member-toolbar').addClass("sticky")
        $('.header-container-wrap-content').css("min-height", $('#header-con-member').outerHeight())
        $('#header-con-member').addClass("sticky" )
      else
        $('#member-toolbar').removeClass("sticky")
        $('#header-con-member').removeClass("sticky")

      if $('#gnp-footer').isInViewport()
        $('#btn-done-member').removeClass('sticky')
        $('.btn-done-wrap-content').css("min-height", $('#btn-done-member').outerHeight())
      else
        $('#btn-done-member').addClass('sticky')
  )

  # check is admin
  if groupStatus.role != 'admin'
    return $location.path('/groups')

  $scope.groupDetail = groupInfo
  $scope.userInfo = userInfo
  $scope.permissionData = groupDataService.getPermissionData()
  $scope.curPage = $routeParams.page
  $scope.numBadge = 0

  $scope.displayPrivacy = (privacy) ->
    if privacy
    then $filter('translate')('_GROUP.LIST.PUBLIC_GROUP')
    else $filter('translate')('_GROUP.LIST.PRIVATE_GROUP')

  $scope.displayMemberRequest = ->
    params =
      id : $scope.groupDetail.id
      page_size : 1
      page : 1
      status : 'pending'
    GroupMemberService.listMemRequest(params).then (data) ->
      $scope.numBadge = data.total

  $scope.displayTitle = ->
    if $routeParams.page == 'list-request'
      return $filter('translate')('_GROUP_MEMBERS.REQUEST')
    $filter('translate')('_GROUP_MEMBERS.EDIT_MEMBER')

  $scope.goToListMember = ->
    $location.path("/groups/#{$scope.groupDetail.id}/members/list-members")
  $scope.goToGroup = ->
    $location.path("/groups/#{$scope.groupDetail.id}")
  $scope.goToListRequest = ->
    $location.path("/groups/#{$scope.groupDetail.id}/members/list-request")

  $scope.$on 'gnp.group.request.changed', (event, data) ->
    $scope.numBadge = data

  $scope.displayMemberRequest()

GroupMembersDetailCtrl.$inject = [
  '$scope'
  '$filter'
  '$location'
  '$routeParams'
  'groupInfo'
  'userInfo'
  'groupStatus'
  'GroupMemberService'
  'groupDataService'
]

module.exports = GroupMembersDetailCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-members-detail-controller.coffee